<template>
	<div>
		<v-text-field
			label="名称"
			v-model="form.name"
			style="max-width: 24rem"
			:error-messages="errors.name"
		></v-text-field>
		<v-text-field
			label="编码"
			v-model="form.code"
			style="max-width: 24rem"
			:readonly="lockedCode"
			hint="字母开头，区分大小写。后台管理接口认编码 admin。"
			persistent-hint
			:error-messages="errors.code"
		></v-text-field>
		<div class="d-flex flex-row align-center flex-wrap mt-2">
			状态：
			<v-radio-group v-model="form.status" inline hide-details="auto">
				<v-radio
					v-for="item in refs['RoleStatus'] || []"
					:key="item.value"
					:label="item.title"
					:value="item.value"
				></v-radio>
			</v-radio-group>
			<span v-if="errors.status" class="text-error ml-2">{{ errors.status }}</span>
			<v-text-field
				class="ml-4"
				label="排序"
				v-model.number="form.sort_order"
				type="number"
				style="max-width: 8rem"
				hide-details
			></v-text-field>
		</div>
		<v-textarea
			class="mt-2"
			v-model="form.description"
			label="备注"
			rows="2"
			:error-messages="errors.description"
		></v-textarea>

		<div class="mt-4">
			<div class="d-flex align-center mb-1">
				<span class="text-subtitle-2">菜单权限</span>
				<span v-if="isAdminRole" class="text-caption text-medium-emphasis ml-2">
					管理员默认拥有全部菜单
				</span>
				<template v-else>
					<v-btn size="x-small" variant="text" color="primary" class="ml-2" @click="selectAllMenus">
						全选
					</v-btn>
					<v-btn size="x-small" variant="text" @click="clearMenus">清空</v-btn>
				</template>
			</div>
			<div v-if="errors.menu_keys" class="text-error text-caption mb-1">{{ errors.menu_keys }}</div>
			<div v-for="item in menuTree" :key="item.key" class="mb-1">
				<template v-if="item.children?.length">
					<div class="text-body-2 font-weight-medium">{{ item.title }}</div>
					<div class="d-flex flex-wrap pl-2">
						<v-checkbox
							v-for="sub in item.children"
							:key="sub.key"
							v-model="menuKeys"
							:label="sub.title"
							:value="sub.key"
							:disabled="isAdminRole"
							hide-details
							density="compact"
							class="mr-2"
						></v-checkbox>
					</div>
				</template>
				<v-checkbox
					v-else
					v-model="menuKeys"
					:label="item.title"
					:value="item.key"
					:disabled="isAdminRole"
					hide-details
					density="compact"
				></v-checkbox>
			</div>
		</div>

		<slot name="actions" :object="submitObject"></slot>
	</div>
</template>

<script>
import { clone } from 'lodash-es'

function flattenMenu(menu = []) {
	const tree = []
	for (const item of menu) {
		const key = item.to || item.title
		if (item.items?.length) {
			tree.push({
				title: item.title,
				key,
				children: item.items
					.filter((sub) => sub.to)
					.map((sub) => ({ title: sub.title, key: sub.to }))
			})
		} else if (item.to) {
			tree.push({ title: item.title, key: item.to, children: [] })
		}
	}
	return tree
}

function allMenuKeys(tree) {
	const keys = []
	for (const item of tree) {
		if (item.children?.length) {
			item.children.forEach((c) => keys.push(c.key))
		} else {
			keys.push(item.key)
		}
	}
	return keys
}

export default {
	name: 'RoleForm',
	props: {
		value: Object,
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			form: {},
			refs: {},
			menuKeys: [],
			menuTree: []
		}
	},
	computed: {
		lockedCode() {
			return this.form.id && this.form.code === 'admin'
		},
		isAdminRole() {
			return this.form.code === 'admin'
		},
		submitObject() {
			return {
				...this.form,
				menu_keys: this.isAdminRole ? [] : [...this.menuKeys]
			}
		}
	},
	mounted() {
		this.menuTree = flattenMenu(this.$soul?.menu || [])
		this.syncForm(this.value)
		this.$api.common.meta('acl', 'RoleStatus', (res) => {
			this.refs = res
		})
	},
	watch: {
		value: {
			handler(val) {
				this.syncForm(val)
			},
			immediate: true
		}
	},
	methods: {
		syncForm(val) {
			this.form = clone(val || {})
			if (!this.form.status) this.form.status = 'valid'
			if (this.form.sort_order == null || this.form.sort_order === '') this.form.sort_order = 0
			if (Array.isArray(this.form.menu_keys)) {
				this.menuKeys = [...this.form.menu_keys]
			} else if (!this.form.id) {
				this.menuKeys = []
			}
			if (this.form.id) this.loadMenus(this.form.id)
		},
		loadMenus(id) {
			if (!id) return
			if (this.form.code === 'admin') {
				this.menuKeys = allMenuKeys(this.menuTree)
				return
			}
			this.$api.acl.menusOfRole(
				id,
				(res) => {
					this.menuKeys = res?.menu_keys || []
				},
				() => {
					this.menuKeys = []
				}
			)
		},
		selectAllMenus() {
			this.menuKeys = allMenuKeys(this.menuTree)
		},
		clearMenus() {
			this.menuKeys = []
		}
	}
}
</script>
